import React from "react";
import { ArrowRight, ArrowDown } from "lucide-react";
import { REGISTRATION_URL, SITE } from "@/lib/config";

const HERO_IMG =
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_join-asatta/artifacts/y5gvwgh4_image.png";

export default function Hero() {
    return (
        <section
            data-testid="hero-section"
            className="relative bg-white border-b border-[#E2E4E9]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 lg:pt-28 pb-20 lg:pb-28">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                    {/* Text */}
                    <div className="lg:col-span-7">
                        <div className="reveal-up inline-flex items-center gap-2 border border-[#082050]/15 px-3 py-1.5 text-xs uppercase tracking-widest text-[#082050]/80">
                            <span className="w-1.5 h-1.5 bg-[#082050]" />
                            Asociación · Tarifa, Cádiz
                        </div>
                        <h1
                            data-testid="hero-heading"
                            className="reveal-up reveal-up-delay-1 mt-6 text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#082050] leading-[1.05] tracking-tight"
                        >
                            La voz de los alojamientos turísticos
                            <span className="block text-[#082050]/60">de Tarifa.</span>
                        </h1>
                        <p className="reveal-up reveal-up-delay-2 mt-6 text-lg text-[#4A5568] max-w-xl leading-relaxed">
                            Hoteles, campings, hostales y apartamentos turísticos unidos
                            para representar al sector, ganar visibilidad y crecer con
                            proyectos comunes. Únete por solo{" "}
                            <span className="text-[#082050] font-medium">
                                {SITE.quota}
                            </span>
                            .
                        </p>
                        <p className="reveal-up reveal-up-delay-2 mt-3 text-sm text-[#4A5568] max-w-xl leading-relaxed">
                            {SITE.commitment}
                        </p>

                        <div className="reveal-up reveal-up-delay-3 mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
                            <a
                                href={REGISTRATION_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="btn-hazte-socio-hero"
                                className="inline-flex items-center gap-2 bg-[#082050] text-white px-8 py-4 text-sm font-medium hover:bg-[#082050]/90 transition-transform hover:-translate-y-0.5"
                            >
                                Hazte socio
                                <ArrowRight size={16} />
                            </a>
                            <a
                                href="#ventajas"
                                data-testid="btn-ver-ventajas"
                                className="inline-flex items-center gap-2 border border-[#082050] text-[#082050] px-8 py-4 text-sm font-medium hover:bg-[#082050]/5"
                            >
                                Ver ventajas
                                <ArrowDown size={16} />
                            </a>
                        </div>

                        <div className="reveal-up reveal-up-delay-4 mt-12 grid grid-cols-3 gap-6 max-w-lg">
                            {[
                                { n: "60+", l: "Alojamientos" },
                                { n: "15€", l: "Cuota mensual" },
                                { n: "365", l: "Días al año" },
                            ].map((s) => (
                                <div key={s.l} className="border-l border-[#082050]/15 pl-4">
                                    <div className="text-2xl sm:text-3xl font-semibold text-[#082050]">
                                        {s.n}
                                    </div>
                                    <div className="text-xs uppercase tracking-widest text-[#718096] mt-1">
                                        {s.l}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Visual */}
                    <div className="lg:col-span-5">
                        <div className="reveal-up reveal-up-delay-2 relative">
                            <div className="relative overflow-hidden aspect-[4/5] w-full border border-[#E2E4E9]">
                                <img
                                    src={HERO_IMG}
                                    alt="Puerto de Tarifa con castillo de Guzmán el Bueno al fondo. Vista panorámica de la ciudad de Tarifa, Cádiz."
                                    className="w-full h-full object-cover"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#082050]/70 via-[#082050]/10 to-transparent" />
                                <div className="absolute bottom-0 left-0 right-0 p-6">
                                    <div className="bg-white text-[#082050] px-4 py-3 border border-[#082050]/10">
                                        <div className="text-[10px] uppercase tracking-widest text-[#718096]">
                                            Únete por
                                        </div>
                                        <div className="text-xl font-semibold">{SITE.quota}</div>
                                        <div className="mt-2 text-[11px] leading-snug text-[#4A5568]">
                                            {SITE.commitment}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="hidden lg:block absolute -bottom-6 -left-6 w-24 h-24 border border-[#082050]/15" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
